import React from 'react';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { usePressureControl } from '../../../hooks/use-pressure-control';
import { SensorControlBox } from '../../../../../../../components/sensor-control-box';

type PressureControlProps = {
  channel: IDeviceChannel;
  isListItem?: boolean;
};

const PressureControl: React.FC<PressureControlProps> = ({ channel, isListItem }) => {
  const { pressure } = usePressureControl(channel);

  return <SensorControlBox isListItem={isListItem} value={pressure?.Pressure?.toFixed(1) || '-'} unit={'hPa'} />;
};

export default PressureControl;
